import { deepDive } from "@/mocks/gossip";

export default function DeepDive() {
  return (
    <section id="deep" className="border-b border-foreground-950/10 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-file-search-line" />
            </span>
            <div>
              <h2 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">{deepDive.sectionLabel}</h2>
              <p className="text-xs text-foreground-500">{deepDive.kicker}</p>
            </div>
          </div>
          <span className="hidden items-center gap-1.5 rounded-full border border-foreground-950/15 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 sm:inline-flex">
            <i className="ri-stack-line" /> 多信源标注 · 不预设立场
          </span>
        </div>

        {/* featured long-form */}
        <article className="grid grid-cols-1 overflow-hidden rounded-lg bg-foreground-950 text-background-100 lg:grid-cols-5">
          <div className="lg:col-span-3">
            <img src={deepDive.image} alt="" className="h-full min-h-[240px] w-full object-cover md:min-h-[340px]" />
          </div>
          <div className="flex flex-col justify-center p-5 md:p-8 lg:col-span-2">
            <span className="mb-3 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
              <i className="ri-timer-flash-fill" /> 本周还原样本
            </span>
            <h3 className="font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">{deepDive.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-background-100/85">{deepDive.dek}</p>
            <a href="#lead" className="mt-5 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-950 hover:bg-background-200">
              进入长读档案 <i className="ri-arrow-right-line" />
            </a>
          </div>
        </article>

        {/* D0-D2 columns */}
        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {deepDive.columns.map((c) => (
            <div key={c.heading} className="rounded-lg border border-foreground-950/10 bg-background-50 p-5">
              <div className="mb-3 inline-flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-sm font-bold text-secondary-900">{c.heading.split(" ")[1]}</span>
                <h4 className="font-heading text-base font-bold text-foreground-950">{c.heading.split(" ").slice(1).join(" ")}</h4>
              </div>
              <p className="text-sm leading-relaxed text-foreground-700">{c.body}</p>
            </div>
          ))}
        </div>

        <p className="mt-5 flex items-start gap-2 rounded-md border border-foreground-950/10 bg-background-50 px-4 py-3 text-xs leading-relaxed text-foreground-600">
          <i className="ri-information-line mt-0.5 shrink-0" />
          <span>{deepDive.foot}</span>
        </p>
      </div>
    </section>
  );
}